<template>
  <div ref="modalbox">
    <a-modal v-model="show"
             :centered="true"
             :keyboard="false"
             :footer="null"
             :closable="false"
             :getContainer="()=>this.$refs.modalbox">
      <div class="headbox">
        <span>查看趋势</span>
        <a-icon class="iconbtn"
                type="close"
                @click="close" />
      </div>
      <p style="color:#fff">
      当前浓度<span> {{ currentConcentration.value }} </span
      >,采集时间<span> {{ currentConcentration.time||'--' }} </span>
    </p>
      <div class="date-picker">
        <a-range-picker v-if="reset"
                        :defaultValue="[moment(queryStartDateTime, 'YYYY-MM-DD HH:mm:ss'), moment(queryEndDateTime, 'YYYY-MM-DD HH:mm:ss')]"
                        format="YYYY-MM-DD HH:mm:ss"
                        :showTime="{
              defaultValue: [moment(queryStartDateTime, 'HH:mm:ss'), moment(queryEndDateTime, 'HH:mm:ss')]
          }"
                        @change="onChange"
                        @ok="onOk"
                        :allowClear="false" />
        <a-button @click="checkTime('day')">今天</a-button>
        <a-button @click="checkTime('yesterday')">昨天</a-button>
        <a-button @click="checkTime('threeday')">三天</a-button>
        <a-button @click="checkTime('week')">一周</a-button>
        <a-button @click="checkTime('month')">一月</a-button>
      </div>
      <div class="echart-panel">
        <LineComponent v-if="show"
                       :lineData="lineData"
                       :detector="detector" />
        <p v-if="hasMore"
           style="text-align:center;color: red">由于该时间段数据点过多，暂只返回最新部分数据</p>
      </div>
    </a-modal>
  </div>
</template>
<script>
import LineComponent from "./LineComponent";
import moment from "moment";
export default {
  name: "monitorDetails",
  components: { LineComponent },
  props: {
    historyVisiable: {
      default: false,
      type: Boolean,
    },
    detector: {},
    showType: {
      default: 0,
    },
    currentConcentration: {
      type: Object,
      default: () => ({
        value: 0,
        time: "",
      }),
    },
  },
  data() {
    return {
      queryStartDateTime: "",
      queryEndDateTime: "",
      lineData: [],
      reset: false,
      hasMore: false,
    };
  },
  computed: {
    show: {
      get: function () {
        return this.historyVisiable;
      },
      set: function () {},
    },
  },
  watch: {
    historyVisiable() {
      if (this.historyVisiable) {
        this.reset = false;
        this.$nextTick(() => {
          this.reset = true;
        });
        this.getLineData();
      }
    },
  },
  created() {
    this.queryStartDateTime = moment(new Date()).format("YYYY-MM-DD 00:00:00");
    this.queryEndDateTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  },
  methods: {
    moment,
    getLineData() {
      this.$get(
        this.showType == 0
          ? "monitor/getIndustryConcentrationCurve"
          : this.showType == 1
          ? "monitor/getHouseholdConcentrationCurve"
          : "monitor/getRestaurantConcentrationCurve",
        {
          alarmId: this.detector.alarmId,
          detectorNumber: this.detector.number,
          timeFrom: this.queryStartDateTime,
          timeTo: this.queryEndDateTime,
          // timeFrom: '2019-12-24 00:00:00',
          // timeTo: '2019-12-28 10:37:10'
        }
      ).then((res) => {
        console.log(res);
        this.lineData = res.data.curveData;
        this.hasMore = res.data.hasMore;
      });
      // this.lineData = [[1576598400000,0],[1576598410000,10],[1576598415000,8],
      // [1576598422000,12],[1576598425000,6],[1576598430000,8]]
    },
    onOk() {
      this.getLineData();
    },
    onChange(date, dateString) {
      this.queryStartDateTime = date[0].format("YYYY-MM-DD  HH:mm:ss");
      this.queryEndDateTime = date[1].format("YYYY-MM-DD  HH:mm:ss");
    },
    close() {
      this.queryStartDateTime = moment(new Date()).format(
        "YYYY-MM-DD 00:00:00"
      );
      this.queryEndDateTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      this.$emit("close");
    },
    checkTime(type) {
      let time = +new Date();
      switch (type) {
        case "day":
          this.queryStartDateTime = moment(new Date()).format(
            "YYYY-MM-DD 00:00:00"
          );
          break;
        case "yesterday":
          this.queryStartDateTime = moment(
            new Date(time - 24 * 60 * 60 * 1000)
          ).format("YYYY-MM-DD HH:mm:ss");
          break;
        case "threeday":
          this.queryStartDateTime = moment(
            new Date(time - 3 * 24 * 60 * 60 * 1000)
          ).format("YYYY-MM-DD HH:mm:ss");
          break;
        case "week":
          this.queryStartDateTime = moment(
            new Date(time - 7 * 24 * 60 * 60 * 1000)
          ).format("YYYY-MM-DD HH:mm:ss");
          break;
        case "month":
          this.queryStartDateTime = moment(
            new Date(time - 30 * 24 * 60 * 60 * 1000)
          ).format("YYYY-MM-DD HH:mm:ss");
          break;
      }
      this.queryEndDateTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      this.reset = false;
      this.$nextTick(() => {
        this.reset = true;
      });
      this.getLineData();
    },
  },
};
</script>

<style lang="less" scoped>
.date-picker {
  width: 100%;
  text-align: center;
  line-height: 2vh;
  margin-bottom: 10px;
  font-size: 0.6vw;
}
.echart-panel {
  width: 100%;
  height: 35vh;
  background-color: white;
}
/deep/ .ant-btn {
  height: 1.5vw;
  font-size: 0.6vw;
  // background-color: royalblue;
}
/deep/ .ant-input {
  height: 1.5vw;
  font-size: 0.6vw;
}
/deep/ .columndata {
  background-color: rgb(36, 35, 35) !important;
  color: #fff !important;
}
/deep/ .ant-modal-content,
/deep/ .ant-modal-header {
  border-bottom: 0;
  background-color: rgba(0, 51, 153, 0.898039215686275) !important;
  width: 45vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0.6vw;
}
/deep/ .ant-modal-title {
  font-size: #fff !important;
}
/deep/ .ant-pagination-total-text {
  color: #fff !important;
}
/deep/ .ant-btn {
  background-color: rgba(0, 51, 153, 0.898039215686275) !important;
  color: whitesmoke;
  margin-left: 10px;
  margin-top: 10px;
}
.headbox {
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3vh;
  font-size: 0.8vw;
}
.iconbtn:hover {
  cursor: pointer;
}
.iconbtn {
  font-size: 0.5vw;
}
</style>


// WEBPACK FOOTER //
// src/views/bigscreen/monitor/MonitiorHistory.vue